export const SET_USERWORKFLOW = "SET_USERWORKFLOW";
export const CREATE_USERWORKFLOW = "CREATE_USERWORKFLOW";
export const USERWORKFLOWS_RECEIVED = "USERWORKFLOWS_RECEIVED";
export const SET_VALUE_USERWORKFLOW = "SET_VALUE_USERWORKFLOW";
export const SET_PROPERTY_USERWORKFLOW = "SET_PROPERTY_USERWORKFLOW";
